import React, {useRef, useEffect, Suspense, lazy} from "react";
import {useLocation, Switch} from "react-router-dom";
import AppRoute from "./utils/AppRoute";
import ScrollReveal from "./utils/ScrollReveal";
import {Spinner} from "components/helpers/Loader";
// Layouts
import LayoutDefault from "./layouts/LayoutDefault";
// Private Route
import PrivateRoute from "components/helpers/privateRoute";

const Home = lazy(() => import("./pages/homes"));
const Hotels = lazy(() => import('./pages/hotels'));
const Restaurants = lazy(() => import('./pages/restaurants'));
const ContactUs = lazy(() => import('./pages/contactUs'));
const Login = lazy(() => import('./pages/Login'));
const SignUp = lazy(() => import("./pages/SignUp"));
const BarSignup = lazy(() => import("./pages/bar/Signup"));
const HotelSignup = lazy(() => import("./pages/hotels/Signup"));

const ForgotPassword = lazy(() => import("./pages/forgotPassword/index"));
const UpdatePassword = lazy(() => import( "./pages/forgotPassword/update"));
const HowToUseApp = lazy(() => import("./pages/howToUseApp"));
const PaymentConfirmation = lazy(() => import("./pages/payment/confirmation"));
const StripeCard = lazy(() => import( "./pages/events/stripeCard"));
const Error = lazy(() => import( "./pages/Error"));
const Checkout = lazy(() => import ("./pages/influence/checkout"));

const Events = lazy(() => import("./pages/events"));
const Profile = lazy(() => import("./pages/profile"));
const Influence = lazy(() => import("./pages/influence"));
const InfluenceProfile = lazy(() => import("./pages/influence/profile"));
const Bar = lazy(() => import('./pages/bar/index'));
const BarQrPrint = lazy(() => import('./pages/bar/qrPrint'));
const BarTransactions = lazy(() => import('./pages/bar/transaction'));
const HotelProfile = lazy(() => import("./pages/hotels/profile"));
const HotelReward = lazy(() => import('./pages/hotels/reward'));
const Add = lazy(() => import('./pages/hotels/reward/add'));
const BarVisitor = lazy(() => import('./pages/bar/visitor'));


const PageLoader = () => (
    <div
        style={{
            width: "48px",
            height: "40%",
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
        }}
    >
        <Spinner color={"#dc7f20"}/>
    </div>
);

const App = () => {
    const childRef = useRef();
    let location = useLocation();

    useEffect(() => {
        document.body.classList.add("is-loaded");
        childRef.current.init();
    }, [location]);

    return (
        <Suspense fallback={<PageLoader/>}>
            <ScrollReveal
                ref={childRef}
                children={() => (
                    <Switch>
                        <AppRoute path="/" component={Home} layout={LayoutDefault} exact/>
                        <AppRoute path="/hotels" component={Hotels} exact/>
                        <AppRoute path="/restaurants" component={Restaurants} exact/>
                        <AppRoute path="/contact" component={ContactUs} exact/>
                        <AppRoute path="/how-to" component={HowToUseApp} exact/>
                        <AppRoute path="/login" component={Login} exact/>
                        <AppRoute path="/sign-up" component={SignUp} exact/>

                        <AppRoute path="/recover" component={ForgotPassword} exact/>
                        <AppRoute path="/update-password/:token" component={UpdatePassword} exact/>
                        <AppRoute path="/purchase/:unique" component={Influence} exact/>
                        <AppRoute path="/influence/payment" component={Checkout} exact/>

                        <PrivateRoute path="/profile" component={Profile} exact/>
                        <PrivateRoute path="/user/events" component={Events} exact/>

                        <AppRoute path="/hotel/signup" component={HotelSignup} exact/>
                        <PrivateRoute path="/hotel/profile" component={HotelProfile} exact/>
                        <PrivateRoute path="/hotel/rewards" component={HotelReward} exact/>
                        <PrivateRoute path="/hotel/reward/add" component={Add} exact/>

                        <AppRoute path="/bar/signup" component={BarSignup} exact/>
                        <PrivateRoute path="/bar/profile" component={Bar} exact/>
                        <PrivateRoute path="/bar-qr-print" component={BarQrPrint} exact/>
                        <PrivateRoute path="/bar/transactions" component={BarTransactions} exact/>
                        <PrivateRoute path="/bar/visitor" component={BarVisitor} exact/>

                        <PrivateRoute path="/influence/profile  " component={InfluenceProfile} exact/>

                        <PrivateRoute
                            path="/payment-confirmation"
                            component={PaymentConfirmation}
                            exact
                        />
                        <PrivateRoute
                            path="/events/:event_id/:amount"
                            component={StripeCard}
                            exact
                        />
                        <AppRoute component={Error}/>
                    </Switch>
                )}
            />
        </Suspense>
    );
};

export default App;
